/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class MapApi extends runtime.BaseAPI {
    /**
     * Create Map
     */
    async v2CreateMapRaw(requestParameters, initOverrides) {
        if (requestParameters['viewportId'] == null) {
            throw new runtime.RequiredError('viewportId', 'Required parameter "viewportId" was null or undefined when calling v2CreateMap().');
        }
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2CreateMap().');
        }
        if (requestParameters['cartographicMapCreate'] == null) {
            throw new runtime.RequiredError('cartographicMapCreate', 'Required parameter "cartographicMapCreate" was null or undefined when calling v2CreateMap().');
        }
        const queryParameters = {};
        if (requestParameters['tabId'] != null) {
            queryParameters['tab_id'] = requestParameters['tabId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/map/{viewport_id}`;
        urlPath = urlPath.replace(`{${"viewport_id"}}`, encodeURIComponent(String(requestParameters['viewportId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['cartographicMapCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Map
     */
    async v2CreateMap(requestParameters, initOverrides) {
        const response = await this.v2CreateMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create Map With Viewport
     */
    async v2CreateMapWithViewportRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2CreateMapWithViewport().');
        }
        if (requestParameters['cartographicMapCreate'] == null) {
            throw new runtime.RequiredError('cartographicMapCreate', 'Required parameter "cartographicMapCreate" was null or undefined when calling v2CreateMapWithViewport().');
        }
        const queryParameters = {};
        if (requestParameters['tabId'] != null) {
            queryParameters['tab_id'] = requestParameters['tabId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/map/viewport/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['cartographicMapCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Map With Viewport
     */
    async v2CreateMapWithViewport(requestParameters, initOverrides) {
        const response = await this.v2CreateMapWithViewportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Map
     */
    async v2DeleteMapRaw(requestParameters, initOverrides) {
        if (requestParameters['mapId'] == null) {
            throw new runtime.RequiredError('mapId', 'Required parameter "mapId" was null or undefined when calling v2DeleteMap().');
        }
        if (requestParameters['idCartographicmap'] == null) {
            throw new runtime.RequiredError('idCartographicmap', 'Required parameter "idCartographicmap" was null or undefined when calling v2DeleteMap().');
        }
        const queryParameters = {};
        if (requestParameters['idCartographicmap'] != null) {
            queryParameters['id_cartographicmap'] = requestParameters['idCartographicmap'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/map/{map_id}`;
        urlPath = urlPath.replace(`{${"map_id"}}`, encodeURIComponent(String(requestParameters['mapId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Delete Map
     */
    async v2DeleteMap(requestParameters, initOverrides) {
        const response = await this.v2DeleteMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Map
     */
    async v2GetMapRaw(requestParameters, initOverrides) {
        if (requestParameters['mapId'] == null) {
            throw new runtime.RequiredError('mapId', 'Required parameter "mapId" was null or undefined when calling v2GetMap().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/map/{map_id}`;
        urlPath = urlPath.replace(`{${"map_id"}}`, encodeURIComponent(String(requestParameters['mapId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Map
     */
    async v2GetMap(requestParameters, initOverrides) {
        const response = await this.v2GetMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Tab Maps
     */
    async v2GetTabMapsRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2GetTabMaps().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/map/tab/{tab_id}`;
        urlPath = urlPath.replace(`{${"tab_id"}}`, encodeURIComponent(String(requestParameters['tabId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Tab Maps
     */
    async v2GetTabMaps(requestParameters, initOverrides) {
        const response = await this.v2GetTabMapsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update Map
     */
    async v2UpdateMapRaw(requestParameters, initOverrides) {
        if (requestParameters['mapId'] == null) {
            throw new runtime.RequiredError('mapId', 'Required parameter "mapId" was null or undefined when calling v2UpdateMap().');
        }
        if (requestParameters['cartographicMapUpdate'] == null) {
            throw new runtime.RequiredError('cartographicMapUpdate', 'Required parameter "cartographicMapUpdate" was null or undefined when calling v2UpdateMap().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/map/{map_id}`;
        urlPath = urlPath.replace(`{${"map_id"}}`, encodeURIComponent(String(requestParameters['mapId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['cartographicMapUpdate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update Map
     */
    async v2UpdateMap(requestParameters, initOverrides) {
        const response = await this.v2UpdateMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
